

import { cookies } from '../js/components/cookies';
cookies();

import { filter } from '../js/components/filter';
filter();

import { modal } from '../js/components/modal';
modal();

import { theme } from '../js/components/theme';
theme();

import { accordeon } from '../js/components/accordeon';
accordeon();

import { headerAnim } from '../js/components/header-anim';

headerAnim('.header');

import { scrollTop } from './components/scroll-top';

scrollTop('.footer__btn-top');

import { language } from './components/language';

language();

import { headerProducts } from './components/header-products';
headerProducts();

import { ymap } from './components/ymap';


     
fetch('https://inflave.com/wp-json/inflave/v1/shops')
.then(response => {
    if (!response.ok) {
    throw new Error('Network response was not ok');
    }
    return response.json();
})
.then(jsonData => {
    // Здесь вы можете работать с вашим JSON данными
   
    ymap(jsonData['data']);

})
.catch(error => {
    console.error('There has been a problem with your fetch operation:', error);
});





import { ymapFilter } from './components/ymapfilter';
ymapFilter('.where__filter_check', '.where__filter');
ymapFilter('.js-search-filter', '.where__filter');